import { 
  ErrorPlaceholder,
  LoadingPlaceholder, 
  SimpleDefinitionListItem, 
  SimplePlaceholder 
} from "@components"

import { GET_SITE_META_DATA } from "@graphql"
import { mySqlToLocal } from "@helpers"
import { useQuery } from "@apollo/client"

import { 
  ArrowDownOnSquareIcon,
  ArrowRightStartOnRectangleIcon,
  BookmarkIcon, 
  BookmarkSquareIcon, 
  CalendarDaysIcon, 
  CalendarIcon, 
  CircleStackIcon, 
  UserCircleIcon, 
  UserIcon, 
  UsersIcon 
} from "@heroicons/react/24/outline"

import PropTypes from "prop-types"

const MetaDetails = ({ backButton, clientId }) => {
  const { data, error, loading } = useQuery(GET_SITE_META_DATA, {
    variables: { clientId: clientId },
    fetchPolicy: "no-cache",
  });

  if (loading) {
    return <LoadingPlaceholder classNames="mt-2" caption="Please wait. Loading data..." icon={CircleStackIcon} />;
  }

  if (error) {
    return (
      <ErrorPlaceholder 
        caption="There was a problem loading the site meta data. Please try again." 
        error={error}
      />
    )
  }

  if (!data?.client && !data?.dataCounts) {
    return (
      <SimplePlaceholder icon={CircleStackIcon} title="No Imports">
        <p className="mt-1 text-sm text-gray-500">
          Data is not available. This is most likely because no import has been performed yet.
        </p>
      </SimplePlaceholder>  
    )
  }

  return (
    <div>
      {data.client && (
        <div id="import-details" className="mb-8">
          <h2 className="mb-1 text-lg font-semibold text-content2-foreground">Data Import Details</h2>
          <SimpleDefinitionListItem caption="Type" description={data?.client?.importType?.name} icon={<ArrowDownOnSquareIcon />} />
          <SimpleDefinitionListItem caption="Scheduled" icon={<CalendarIcon />} description={data?.client?.import_scheduled ? "Yes" : "No"} />
          <SimpleDefinitionListItem caption="MIS Data Age" description={data?.client?.data_age} icon={<CalendarDaysIcon />} />
          <SimpleDefinitionListItem caption="Last Import Completed" description={mySqlToLocal(data?.client?.latestImport?.created_at).format('DD/MM/YYYY HH:mm')} icon={<ArrowRightStartOnRectangleIcon />} />
        </div>
      )}

      {data.dataCounts && (
        <div id="data-counts" className="mb-8">
          <h2 className="mb-1 text-lg font-semibold text-content2-foreground">Data Counts</h2>
          <SimpleDefinitionListItem caption="No of Guardians" description={data?.dataCounts?.guardian_counts} icon={<UsersIcon />} />
          <SimpleDefinitionListItem caption="No of Lessons" icon={<BookmarkSquareIcon />} description={data?.dataCounts?.lesson_counts} />        
          <SimpleDefinitionListItem caption="No of Staff" description={data?.dataCounts?.staff_counts} icon={<UserCircleIcon />} />
          <SimpleDefinitionListItem caption="No of Students" description={data?.dataCounts?.student_counts} icon={<UserIcon />} />
          <SimpleDefinitionListItem caption="No of Subjects" description={data?.dataCounts?.subject_counts} icon={<BookmarkIcon />} />
        </div>
      )}

      {backButton}
    </div>
  )
}

MetaDetails.propTypes = {
  backButton: PropTypes.node.isRequired,
  clientId: PropTypes.string.isRequired,
}

export default MetaDetails